import React, { ReactNode, useEffect, useMemo } from "react";
import { useScroller } from "../../hooks/useScroller";
import { ScrollerProps } from "../../../../types";

const Scroller = ({
  settings,
  get,
  className,
  style,
  renderRow,
  controlledRef,
  onScroll,
  scrollTop,
  showPaginator,
  rowKey,
}: ScrollerProps) => {
  const { topPaddingHeight, bottomPaddingHeight, data, runScroller } =
    useScroller(settings, get, scrollTop);

  useEffect(() => {
    if (!settings.initialScrollPosition) {
      runScroller({
        target: { scrollTop: scrollTop },
      } as unknown as React.UIEvent<HTMLDivElement>);
    }
  }, [settings.initialScrollPosition, scrollTop, runScroller]);

  const rows = useMemo(
    () =>
      data.map((row) => (
        <React.Fragment key={row[rowKey]}>{renderRow(row)}</React.Fragment>
      )),
    [data]
  );

  return (
    <div
      className={className}
      style={style}
      ref={controlledRef}
      onScroll={(event) => {
        if (showPaginator) return;
        runScroller(event);
        onScroll?.(event);
      }}
    >
      {!showPaginator && <div style={{ height: topPaddingHeight.current }} />}
      {rows}
      {!showPaginator && (
        <div style={{ height: bottomPaddingHeight.current }} />
      )}
    </div>
  );
};

export default Scroller;
